// Index file for the directory. Don't add anything else here.
import CarouselSectionsWithoutBlocks from './CarouselSectionsWithoutBlocks';
export default CarouselSectionsWithoutBlocks;
